import { Pipe, PipeTransform } from "@angular/core";
import { Observable } from "rxjs";
import { Country } from "../../constant/country.constant";

@Pipe({
    name: "country"
})
export class CountryPipe implements PipeTransform {
    transform(value: any, lang = "en"): string {
        return this.getCountryName(value, lang);
    }

    getCountryName(countryCode: string, lang: string): string {
        switch (countryCode) {
            case Country.Thailand: return "Thailand"; break;
            case Country.Philippines: return "Philippines"; break;
            case Country.Myanmar: return "Myanmar"; break;
            case Country.Laos: return "Laos"; break;
            default: return "-";
        }
    }

}
